export default __webpack_public_path__ + "static/media/sunsculpted1.695a33b2.jpg";